import { useFocusRestore } from '#Common/composables/useFocusRestore'

/**
 * Search overlay open state (header-owned instance).
 * Phase 9: restore focus to the control that opened the modal (S32 focus mgmt).
 */
export const useSearchModal = () => {
  const isOpen = ref(false)
  const focusRestore = useFocusRestore()

  const open = () => {
    focusRestore.capture()
    isOpen.value = true
  }

  const close = (options?: { restoreFocus?: boolean }) => {
    const restoreFocus = options?.restoreFocus !== false
    isOpen.value = false
    if (restoreFocus) {
      focusRestore.restore()
    }
    else {
      focusRestore.clear()
    }
  }

  const toggle = () => {
    if (isOpen.value) {
      close()
    }
    else {
      open()
    }
  }

  return {
    isOpen: readonly(isOpen),
    open,
    close,
    toggle,
  }
}
